import React from 'react';
import PlaceholderTool from '../../../components/shared/PlaceholderTool/PlaceholderTool';

/**
 * PhotosPage Component
 * 
 * Page wrapper for the Photos (Fotodokumentation) module.
 * 
 * @component
 */
export default function PhotosPage() {
    return (
        <div className="page-wrapper">
            <PlaceholderTool toolKey="photos" title="Fotos" />
        </div>
    );
}
